// This is made for the tabs component

'use strict';

import { debounce, isBreakpointActive } from './helpers';

const $document = $(document);
const $window = $(window);
const isSmlActive = isBreakpointActive('sml');


if (isSmlActive) {
    $document.on('click', '.js-toggle-tabs, .js-nav-link', function (e) {

        e.preventDefault();
        $(this).closest('.js-nav-tabs').toggleClass('is-active');

    });
}
